/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

export const ImportStatus = {
  CANCELLED: 'CANCELLED',
  MERGING: 'MERGING',
  RESOLVED: 'RESOLVED',
};
